import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Dashboard } from 'components';

import * as common from 'libs/commonFunc';
import * as licenseActions from 'modules/license';
import * as examListActions from 'modules/examList';

class CtDashboard extends Component {
  state = {
    loading: false,
    statisticsData: {},
    monthlyTrainings: [],
    maintainLicense: {}
  }

  componentDidMount() {
    this.getDashboardAll();
  }

  componentDidUpdate(prevProps) {
    // 훈련 실시 후 훈련 정보 재조회
    if (JSON.stringify(this.props.startExamResult) !== JSON.stringify(prevProps.startExamResult)) {
      this.getDashboardAll();
    }
  }

  getDashboardAll = () => {
    this.getDashboard();
    this.getExamList();
    this.getLicense();
  }

  // 훈련 통계 정보 조회
  getDashboard = async () => {
    this.setState({ loading: true });

    try {
      const response = await axios.get('/api/v1/Dashboard');
      if (response && response.data && !response.data.error) {
        const maintainLicense = {
          licenseEndDate: response.data.licenseEndDate,
          licenseHostName: response.data.licenseHostName
        }
        this.setState({
          statisticsData: response.data.statistic,
          monthlyTrainings: response.data.list,
          maintainLicense: maintainLicense
        })
      }
    } catch (e) {
      console.log('dashboard getDashboard error', e);
    }
  }

  // 라이센스 정보 조회
  getLicense = async () => {
    const { LicenseActions } = this.props;

    try {
      await LicenseActions.getLicense();
    } catch (e) {
      console.log('dashboard getLicense error', e);
    }

    this.setState({ loading: false });
  }

  // 훈련 리스트 조회
  getExamList = async () => {
    const { ExamListActions } = this.props;
    try {
      const examParam = {
        examNo: 'all',
        subTab: 'pi',
        examFilter: { "examIng": 1 },
        sort: [{ "field": "examNo", "order": "DESC" }],
        offset: 0,
        limit: 5,
        refresh: true
      }
      await ExamListActions.getExamList(examParam);
    } catch (e) {
      console.log('dashboard getExamList error', e);
    }
  }

  render() {
    const { licenseData, examListOrdering, examListByNo, selectedExamList } = this.props;
    const { statisticsData, monthlyTrainings, loading, maintainLicense } = this.state;

    const licensePeriodList = [];
    const licenseTimesList = [];
    const license = licenseData.toJS();
    if (license.length > 0) {
      license.map(data => {
        const { issueEpoch, licenseType, startEpoch, endEpoch, examUsedCount, examLimitCount } = data;
        // 발급받은 라이센스
        if (!!issueEpoch) {
          if ((licenseType === 1 || licenseType === 2) && common.nowEpoch() >= startEpoch && common.nowEpoch() <= endEpoch) { // 사용중인 기간 라이센스
            licensePeriodList.push(data);
          } else if (licenseType === 4 && examUsedCount !== examLimitCount) { // 사용중인 횟수 라이센스
            licenseTimesList.push(data);
          }
        }
      });
    }

    return (
      <Dashboard
        periodList={licensePeriodList}
        timesList={licenseTimesList}
        statisticsData={statisticsData}
        monthlyTrainings={monthlyTrainings}
        examListOrdering={examListOrdering}
        examListByNo={examListByNo}
        selectedExamList={selectedExamList}
        loading={loading}
        maintainLicense={maintainLicense}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    licenseData: state.license.get('data').get('success'),
    examListOrdering: state.examList.get('examListOrdering'),
    examListByNo: state.examList.get('examListByNo'),
    selectedExamList: state.currentStatus.getIn(['examList', 'selected']),
    startExamResult: state.exam.get('startExamResult').get('success'),
  };
};

const mapDispatchToProps = dispatch => ({
  LicenseActions: bindActionCreators(licenseActions, dispatch),
  ExamListActions: bindActionCreators(examListActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtDashboard);



// WEBPACK FOOTER //
// ./src/script/containers/dashboard/CtDashboard.js